export default __webpack_public_path__ + "static/media/favela.83de5779.jpg";